(() => {
  const init = (scope = document) => {
    const roots = scope.querySelectorAll('[data-bg-product]:not([data-bg-ready])');

    roots.forEach((root) => {
      root.dataset.bgReady = 'true';
    const form = root.querySelector('[data-bg-form]');
    const variantInput = root.querySelector('[data-bg-variant-input]');
    const addButton = root.querySelector('[data-bg-add]');
    const buttonText = root.querySelector('[data-bg-button-text]');
    const status = root.querySelector('[data-bg-status]');

    root.querySelectorAll('[data-bg-bundle]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked || !variantInput) return;
        variantInput.value = radio.value;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = !available;
        if (buttonText) buttonText.textContent = available ? 'Add to cart' : 'Sold out';
      });
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!variantInput?.value || addButton?.disabled) return;

      addButton.disabled = true;
      buttonText.textContent = 'Adding…';
      status.textContent = '';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantInput.value), quantity: 1 }] })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'This bundle could not be added.');

        buttonText.textContent = 'Added to cart';
        status.textContent = 'Your bundle is in the cart. Redirecting to secure checkout…';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: payload }));
        window.setTimeout(() => { window.location.href = '/checkout'; }, 650);
      } catch (error) {
        status.textContent = error instanceof Error ? error.message : 'Please try again.';
        buttonText.textContent = 'Add to cart';
        addButton.disabled = false;
      }
    });

    root.querySelector('[data-bg-scroll]')?.addEventListener('click', () => {
      root.querySelector('.bg-product__bundles')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    const mobileBar = root.querySelector('[data-bg-mobile-bar]');
    if (mobileBar && form) {
      const observer = new IntersectionObserver(([entry]) => {
        mobileBar.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.1 });
      observer.observe(form);
    }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
